import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import TextField from "@material-ui/core/TextField/index";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import Accordion from "./AccordionCreate";

const initialValues = {
  name: "",
  permissionIds: [],
};

export default function Create(props) {
  const { show, onHide, onRoles } = props;

  const [isError, setIsError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [oldValue, setOldValue] = useState([]);

  const CreateSchema = Yup.object().shape({
    name: Yup.string().required("Ad tələb olunur"),
  });

  const getInputClasses = (filedName) => {
    if (formik.touched[filedName] && formik.errors[filedName]) {
      return true;
    }
    if (formik.touched[filedName] && !formik.errors[filedName]) {
      return false;
    }

    return false;
  };

  const onPostRole = (values, resetForm, setSubmitting) => {
    setIsLoading(true);

    const roleName = {
      name: values.name,
    };
    const rolePermission = {
      permissionIds: oldValue,
    };

    axios
      .post(
        `${process.env.REACT_APP_API_URL}role?name=${roleName.name}`,
        rolePermission
      )
      .then((res) => {
        onRoles();
        setIsLoading(false);
        setIsError(false);
        setSubmitting(false);
        resetForm();
        onHide(false);
      })
      .catch((err) => {
        let message =
          typeof err.response !== "undefined"
            ? err.response.data.message
            : err.message;
        setIsError(message);
        setIsLoading(false);
      });
  };

  const [user, setUser] = useState([]);
  const [card, setCard] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [deviceModel, setDeviceModel] = useState([]);
  const [devicePlace, setDevicePlace] = useState([]);
  const [deviceType, setDeviceType] = useState([]);
  const [duty, setDuty] = useState([]);
  const [structure, setStructure] = useState([]);
  const [limit, setLimit] = useState([]);
  const [role, setRole] = useState([]);
  const [employeeReport, setEmployeeReport] = useState([]);
  const [employeeBiometricReport, setEmployeeBiometricReport] = useState([]);
  const [deviceOperationReport, setDeviceOperationReport] = useState([]);
  const [deviceReport, setDeviceReport] = useState([]);
  const [syncData, setSyncData] = useState([]);
  const [device, setDevice] = useState([]);
  const [deviceUser, setDeviceUser] = useState([]);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}permission`).then((res) => {
      const displayTypes = res.data.map(({ id, description, type }) => ({
        value: id,
        label: description,
        type: type,
      }));

      console.log(displayTypes, "dt");
      const newUser = displayTypes.filter((obj) => {
        return obj.type === "user";
      });
      const newCard = displayTypes.filter((obj) => {
        return obj.type === "card";
      });
      const newEmployees = displayTypes.filter((obj) => {
        return obj.type === "employees";
      });
      const newDeviceModel = displayTypes.filter((obj) => {
        return obj.type === "device_model";
      });
      const newDevicePlace = displayTypes.filter((obj) => {
        return obj.type === "device_place";
      });
      const newDeviceType = displayTypes.filter((obj) => {
        return obj.type === "device_type";
      });
      const newDuty = displayTypes.filter((obj) => {
        return obj.type === "duty";
      });
      const newStructure = displayTypes.filter((obj) => {
        return obj.type === "structure";
      });
      const newLimit = displayTypes.filter((obj) => {
        return obj.type === "limit";
      });
      const newRole = displayTypes.filter((obj) => {
        return obj.type === "role";
      });
      const newEmployeesReport = displayTypes.filter((obj) => {
        return obj.type === "employee_report";
      });
      const newEmployeeBiometricReport = displayTypes.filter((obj) => {
        return obj.type === "employee_biometric_report";
      });
      const newDeviceOperationReport = displayTypes.filter((obj) => {
        return obj.type === "device_operation_report";
      });
      const newDeviceReport = displayTypes.filter((obj) => {
        return obj.type === "device_report";
      });
      const newSyncData = displayTypes.filter((obj) => {
        return obj.type === "sync_data";
      });
      const newDevice = displayTypes.filter((obj) => {
        return obj.type === "devices";
      });
      const newDeviceUser = displayTypes.filter((obj) => {
        return obj.type === "device_user";
      });
      setUser(newUser);
      setCard(newCard);
      setEmployees(newEmployees);
      setDeviceModel(newDeviceModel);
      setDevicePlace(newDevicePlace);
      setDeviceType(newDeviceType);
      setDuty(newDuty);
      setStructure(newStructure);
      setLimit(newLimit);
      setRole(newRole);
      setEmployeeReport(newEmployeesReport);
      setEmployeeBiometricReport(newEmployeeBiometricReport);
      setDeviceOperationReport(newDeviceOperationReport);
      setDeviceReport(newDeviceReport);
      setSyncData(newSyncData);
      setDevice(newDevice);
      setDeviceUser(newDeviceUser);
    });
  }, []);

  const formik = useFormik({
    initialValues,
    validationSchema: CreateSchema,
    onSubmit: (values, { resetForm, setSubmitting }) => {
      onPostRole(values, resetForm, setSubmitting);
    },
  });

  const resetForm = () => {
    onHide();
    formik.resetForm();
  };

  useEffect(() => {
    setIsError("");
  }, [show]);

  return (
    <Modal
      show={show}
      onHide={resetForm}
      aria-labelledby="edit"
      size="lg"
      centered
    >
      <form onSubmit={formik.handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title id="edit">Əlavə et</Modal.Title>
        </Modal.Header>
        <Modal.Body className="log-body-modal">
          <div className="col-12 pl-4 pr-4 ">
            <div className="row">
              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="name"
                    label="Ad"
                    placeholder="Ad"
                    className="w-100"
                    error={getInputClasses("name")}
                    {...formik.getFieldProps("name")}
                  />
                </div>
                {formik.touched.name && formik.errors.name ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.name}</div>
                  </div>
                ) : null}
              </div>
              <div className="col-12 col-md-12 col-lg-12">
                <Accordion
                  data={user}
                  title="İstifadəçilər"
                  setOldValue={setOldValue}
                  oldValue={oldValue}
                />
                <Accordion
                  data={card}
                  title="Kartlar"
                  setOldValue={setOldValue}
                  oldValue={oldValue}
                />
                <Accordion
                  data={employees}
                  title="İnsan resursları"
                  setOldValue={setOldValue}
                  oldValue={oldValue}
                />
                <Accordion
                  data={deviceModel}
                  title="Qurğu modeli"
                  setOldValue={setOldValue}
                  oldValue={oldValue}
                />
                <Accordion
                  data={deviceType}
                  title="Qurğu tipi"
                  setOldValue={setOldValue}
                  oldValue={oldValue}
                />
                <Accordion
                  data={devicePlace}
                  title="Qurğu məkanı"
                  setOldValue={setOldValue}
                  oldValue={oldValue}
                />
                <Accordion
                  data={structure}
                  title="Daxili struktur"
                  setOldValue={setOldValue}
                  oldValue={oldValue}
                />
                <Accordion
                  data={duty}
                  title="Vəzifələr"
                  setOldValue={setOldValue}
                  oldValue={oldValue}
                />
                <Accordion
                  data={limit}
                  title="Barmaq izi və kart limit"
                  setOldValue={setOldValue}
                  oldValue={oldValue}
                />
                <Accordion
                  data={role}
                  title="Rollar"
                  setOldValue={setOldValue}
                  oldValue={oldValue}
                />
                <Accordion
                  data={employeeReport}
                  title="Əməkdaşlar üzrə hesabat"
                  setOldValue={setOldValue}
                  oldValue={oldValue}
                />
                <Accordion
                  data={employeeBiometricReport}
                  title="Biometrik Əməkdaşlar üzrə hesabat"
                  setOldValue={setOldValue}
                  oldValue={oldValue}
                />
                <Accordion
                  data={deviceOperationReport}
                  title="Qurğu əməliyyat hesabatı"
                  setOldValue={setOldValue}
                  oldValue={oldValue}
                />
                <Accordion
                  data={deviceReport}
                  title="Qurğular hesabatı"
                  setOldValue={setOldValue}
                  oldValue={oldValue}
                />
                <Accordion
                  data={syncData}
                  title="Sinxronizasiya ayarları"
                  setOldValue={setOldValue}
                  oldValue={oldValue}
                />
                <Accordion
                  data={device}
                  title="Qurğular"
                  setOldValue={setOldValue}
                  oldValue={oldValue}
                />
                <Accordion
                  data={deviceUser}
                  title="Qurğudakı əməkdaşlar"
                  setOldValue={setOldValue}
                  oldValue={oldValue}
                />

                {isError && (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block MuiFormLabel-root Mui-error">
                      {isError}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="light"
            onClick={() => {
              onHide(false);
              formik.resetForm();
            }}
          >
            Bağla
          </Button>
          <Button type="submit" className={isLoading ? "px-9" : ""}>
            <span>Əlavə et</span>
            {isLoading && <span className="ml-3 spinner spinner-white"></span>}
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
